import React from 'react';
import PropTypes from 'prop-types';

import './CFSForm.css';
import { SubmitFailedMessage, InProgress, MissingFieldsMessage } from './Messages';
import { AddSpeakerButton } from './Buttons';
import SpeakerDetail from './SpeakerDetail';

const CFSForm = ({
    closeAlert,
    fields,
    formFailed,
    formSubmitInProgress,
    isValidForm,
    isValidValue,
    onSubmit,
    updateValue,
    addSpeaker,
    updateSpeaker,
    removeSpeaker,
    isValidSpeakerValue
}) => (
    <div className="container cfs-form">
        <form className="form-horizontal" noValidate onSubmit={onSubmit}>
            <div className="is-divider custom-divider" data-content="Talk detail" />
            <div className="form-group columns">
                <label
                    className={`control column is-2 label ${
                        isValidValue('talkTitle') ? '' : ' has-error'
                    }`}
                    htmlFor="talkTitle"
                >
                    {fields.talkTitle.label}
                </label>
                <div className="column fix-space-sm">
                    <input
                        className={`form-control input is-rounded ${
                            isValidValue('talkTitle') ? '' : ' is-danger'
                        }`}
                        name="talkTitle"
                        onChange={updateValue}
                        placeholder={fields.talkTitle.placeholder}
                        type="text"
                        value={fields.talkTitle.value}
                    />
                </div>
                <label
                    className={`control column is-2 label${
                        isValidValue('stream') ? '' : ' has-error'
                    }`}
                    htmlFor="stream"
                >
                    {fields.stream.label}
                </label>
                <div className="column">
                    <div
                        className={`select custom-select-sm level-right is-rounded ${
                            isValidValue('stream') ? '' : ' is-danger'
                        }`}
                    >
                        <select
                            className="custom-select"
                            name="stream"
                            onChange={updateValue}
                            value={fields.stream.value}
                        >
                            <option value="">Select stream</option>
                            <option>Innovations (40 minutes)</option>
                            <option>Security (40 minutes)</option>
                            <option>Digital Transformation (40 minutes)</option>
                            <option>Interfaces (40 minutes)</option>
                            <option>Data (40 minutes)</option>
                            <option>Live Coding Session (20 minutes)</option>
                            <option>Lightning Talk (10 minutes)</option>
                            <option>Hands-on Lab (180 minutes)</option>
                        </select>
                    </div>
                </div>
            </div>
            <div className="form-group columns">
                <label
                    className={`control column is-2 label ${
                        isValidValue('talkSummary') ? '' : ' has-error'
                    }`}
                    htmlFor="talkSummary"
                >
                    {fields.talkSummary.label}
                </label>
                <div className="column">
                    <textarea
                        className={`form-control textarea ${
                            isValidValue('talkSummary') ? '' : ' is-danger'
                        }`}
                        name="talkSummary"
                        onChange={updateValue}
                        placeholder={fields.talkSummary.placeholder}
                        rows="2"
                        value={fields.talkSummary.value}
                    />
                </div>
            </div>
            <div className="form-group field is-horizontal columns">
                <label
                    className={`control column is-2 is-left label ${
                        isValidValue('talkType') ? '' : ' has-error'
                    }`}
                    htmlFor="talkType"
                >
                    {fields.talkType.label}
                </label>
                <div
                    className={`control field column ${
                        isValidValue('talkType') ? '' : ' has-error'
                    }`}
                >
                    <div className="field is-left is-horizontal">
                        <label className="radio">
                            <input
                                name="talkType"
                                onChange={updateValue}
                                type="radio"
                                value="introduction"
                            />{' '}
                            Introduction
                        </label>
                    </div>
                    <div className="field is-left is-horizontal">
                        <label className="radio">
                            <input
                                name="talkType"
                                onChange={updateValue}
                                type="radio"
                                value="advanced"
                            />{' '}
                            Advanced
                        </label>
                    </div>
                    <div className="field is-left is-horizontal">
                        <label className="radio">
                            <input
                                name="talkType"
                                onChange={updateValue}
                                type="radio"
                                value="expert"
                            />{' '}
                            Deep Dive
                        </label>
                    </div>
                </div>
                <label
                    className={`control column is-2 is-left label ${
                        isValidValue('audienceLevel') ? '' : ' has-error'
                    }`}
                    htmlFor="audienceLevel"
                >
                    {fields.audienceLevel.label}
                </label>
                <div
                    className={`control field column ${
                        isValidValue('audienceLevel') ? '' : ' has-error'
                    }`}
                >
                    <div className="field is-left is-horizontal">
                        <label className="radio">
                            <input
                                name="audienceLevel"
                                onChange={updateValue}
                                type="radio"
                                value="beginner"
                            />{' '}
                            Beginner
                        </label>
                    </div>
                    <div className="field is-left is-horizontal">
                        <label className="radio">
                            <input
                                name="audienceLevel"
                                onChange={updateValue}
                                type="radio"
                                value="intermediate"
                            />{' '}
                            Intermediate
                        </label>
                    </div>
                    <div className="field is-left is-horizontal">
                        <label className="radio">
                            <input
                                name="audienceLevel"
                                onChange={updateValue}
                                type="radio"
                                value="expert"
                            />{' '}
                            Expert
                        </label>
                    </div>
                    <div className="field is-left is-horizontal">
                        <label className="radio">
                            <input
                                name="audienceLevel"
                                onChange={updateValue}
                                type="radio"
                                value="everyone"
                            />{' '}
                            Everyone
                        </label>
                    </div>
                </div>
            </div>
            <div className="form-group field is-horizontal columns">
                <label
                    className={`control column is-2 label ${
                        isValidValue('liveCoding') ? '' : ' has-error'
                    }`}
                    htmlFor="liveCoding"
                >
                    {fields.liveCoding.label}
                </label>
                <div
                    className={`field-body control column ${
                        isValidValue('liveCoding') ? '' : ' has-error'
                    }`}
                >
                    <label className="radio radio-inline">
                        <input
                            checked={fields.liveCoding.value === 'yes'}
                            name="liveCoding"
                            onChange={updateValue}
                            type="radio"
                            value="yes"
                        />{' '}
                        Yes
                    </label>
                    <label className="radio radio-inline">
                        <input
                            checked={fields.liveCoding.value === 'no'}
                            name="liveCoding"
                            onChange={updateValue}
                            type="radio"
                            value="no"
                        />{' '}
                        No
                    </label>
                </div>
            </div>
            <div className="form-group field is-horizontal columns">
                <label
                    className={`control column is-2 label ${
                        isValidValue('technicalOrBusiness') ? '' : ' has-error'
                    }`}
                    htmlFor="technicalOrBusiness"
                >
                    {fields.technicalOrBusiness.label}
                </label>
                <div
                    className={`field-body control column ${
                        isValidValue('technicalOrBusiness') ? '' : ' has-error'
                    }`}
                >
                    <label className="radio radio-inline">
                        <input
                            checked={fields.technicalOrBusiness.value === 'technical'}
                            name="technicalOrBusiness"
                            onChange={updateValue}
                            type="radio"
                            value="technical"
                        />{' '}
                        Technical
                    </label>
                    <label className="radio radio-inline">
                        <input
                            checked={fields.technicalOrBusiness.value === 'business'}
                            name="technicalOrBusiness"
                            onChange={updateValue}
                            type="radio"
                            value="business"
                        />{' '}
                        Business
                    </label>
                </div>
            </div>
            {fields.speakers.map(speaker => (
                <SpeakerDetail
                    fields={fields}
                    isValidSpeakerValue={isValidSpeakerValue}
                    key={speaker.id}
                    removeSpeaker={removeSpeaker}
                    speaker={speaker}
                    updateSpeaker={updateSpeaker}
                />
            ))}
            {fields.speakers.length < 5 && <AddSpeakerButton addSpeaker={addSpeaker} />}
            <div className="is-divider custom-divider" data-content="Social media" />
            <div className="form-group columns">
                <label
                    className={`control column is-2 label  ${
                        isValidValue('twitterPromotion') ? '' : ' has-error'
                    }`}
                    htmlFor="twitterPromotion"
                >
                    {fields.twitterPromotion.label}
                </label>
                <div className="column">
                    <textarea
                        className={`form-control textarea ${
                            isValidValue('twitterPromotion') ? '' : ' is-danger'
                        }`}
                        maxLength="120"
                        name="twitterPromotion"
                        onChange={updateValue}
                        placeholder={fields.twitterPromotion.placeholder}
                        rows="2"
                        value={fields.twitterPromotion.value}
                    />
                </div>
            </div>
            <div className="form-group columns">
                <label
                    className={`control column is-2 label ${
                        isValidValue('fbPromotion') ? '' : ' has-error'
                    }`}
                    htmlFor="fbPromotion"
                >
                    {fields.fbPromotion.label}
                </label>
                <div className="column">
                    <textarea
                        className={`form-control textarea ${
                            isValidValue('fbPromotion') ? '' : ' is-danger'
                        }`}
                        maxLength="300"
                        name="fbPromotion"
                        onChange={updateValue}
                        placeholder={fields.fbPromotion.placeholder}
                        rows="2"
                        value={fields.fbPromotion.value}
                    />
                </div>
            </div>
            <div className="columns">
                <div className="first-consent-section column is-10 is-offset-2">
                    <h2 className="title is-5 consent-title">Acknowledgement and consent</h2>
                    <p>
                        You agree by ticking the below “yes” box that companies Accenture s.r.o.,
                        Id. No.: 35 724 498 and Accenture Technology Solutions – Slovakia, s.r.o.
                        Id. No.: 35 864 648, seated both at Plynárenská 7/C, 821 09 Bratislava, in
                        connection with the conference OpenSlava 2019:
                    </p>
                    <ul>
                        <li>
                            may process your personal data indicated herein, except for the e-mail
                            address, including publishing in any material published or distributed
                            to individuals, through any type of media including social media (e.g.
                            online, print, TV);
                        </li>
                        <li>
                            may use/publish your photographs and/or video/audio recordings of your
                            participation and presentation to promote and inform about the event.
                        </li>
                    </ul>
                    <p className="acknowledgement">
                        I acknowledge having read and understood this privacy statement, and consent
                        to the above:
                    </p>
                </div>
            </div>
            <div
                className={`form-group is-horizontal columns checkbox field control ${
                    isValidValue('disclaimer') ? '' : ' has-error'
                }`}
            >
                <label className="column field is-offset-2 cfs-disclaimer">
                    <input
                        checked={fields.disclaimer.value}
                        name="disclaimer"
                        onChange={updateValue}
                        type="checkbox"
                    />{' '}
                    {fields.disclaimer.label}
                </label>
            </div>
            <div className="columns">
                <div className="second-consent-section column is-10 is-offset-2">
                    <p>
                        Your privacy is important to us. Accenture uses your personal data only in
                        compliance with data protection laws. For further information on how
                        Accenture processes your personal data, please see our{' '}
                        <a
                            href="https://www.accenture.com/us-en/privacy-policy"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            Accenture Privacy Statement
                        </a>
                        .
                    </p>
                </div>
            </div>
            <MissingFieldsMessage isValidForm={isValidForm} />
            <SubmitFailedMessage closeAlert={closeAlert} formFailed={formFailed} />
            <InProgress formSubmitInProgress={formSubmitInProgress} />
            <div className="submit">
                <button
                    className="button is-large is-rounded btn-submit"
                    disabled={!isValidForm() || formSubmitInProgress}
                    type="submit"
                >
                    Submit
                </button>
            </div>
        </form>
    </div>
);

CFSForm.propTypes = {
    addSpeaker: PropTypes.func.isRequired,
    closeAlert: PropTypes.func.isRequired,
    // eslint-disable-next-line
    fields: PropTypes.object.isRequired,
    formFailed: PropTypes.bool.isRequired,
    formSubmitInProgress: PropTypes.bool.isRequired,
    isValidForm: PropTypes.func.isRequired,
    isValidSpeakerValue: PropTypes.func.isRequired,
    isValidValue: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    removeSpeaker: PropTypes.func.isRequired,
    updateSpeaker: PropTypes.func.isRequired,
    updateValue: PropTypes.func.isRequired
};

export default CFSForm;
